import updateOverflowTitle from '../../../../Component/UI/updateOverflowTitle';
import styled from 'styled-components';
import { OrderList } from '../../../../Component/Interface/Order';
import { OrderCell } from '../../../../Component/style/orderTable_style2';
import { orderItemClaimStates } from '../../../../Component/UI/orderClaimProgress';
import RefundTransferDot from '../../../../Component/UI/RefundTransferDot';

export default function BankRefundCell({ order, onRefund }: { order: OrderList; onRefund?: (orderSeq: number) => void }) {
  const refund = order.bank_refund;
  const pending = !refund?.pending_amount && !refund?.amount ? order.order_details.flatMap(detail =>
    orderItemClaimStates(detail.detail_seq, (order.claims || []).filter(claim => claim.items.some(item => item.detail_seq === detail.detail_seq
      && (item.payment_method === 'bank' || detail.payment_method === 'bank'))))).map(state => [state.processing, state.refund].filter(Boolean).join(' · ')) : [];
  const pendingLabel = [...new Set(pending)].join(' · ');
  const summary = [refund?.pending_amount ? `${refund.pending_amount.toLocaleString('ko-KR')}원 환불 대기` : '',
    pendingLabel,
    refund?.amount ? `${refund.amount.toLocaleString('ko-KR')}원 ${refund.remaining_amount > 0 ? '일부 환불 완료' : '환불 완료'}` : '',
    refund?.completed_at ? new Date(refund.completed_at).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', hour12: false }) : '',
    refund?.completed_by ? `처리자: ${refund.completed_by}` : ''].filter(Boolean).join(' · ');
  return <OrderCell><Content><Summary onMouseEnter={event => updateOverflowTitle(event.currentTarget, summary)}>
    {!!refund?.pending_amount && <><RefundTransferDot/><strong>{refund.pending_amount.toLocaleString('ko-KR')}원</strong><span>환불 대기</span></>}
    {refund?.amount ? <><strong>{refund.amount.toLocaleString('ko-KR')}원</strong>
      <span>{refund.remaining_amount > 0 ? '일부 환불 완료' : '환불 완료'}</span>
      {refund.completed_at && <small>{new Date(refund.completed_at).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', hour12: false })}</small>}
      {refund.completed_by && <small>처리자: {refund.completed_by}</small>}</>
      : !refund?.pending_amount && <span>{pendingLabel || (refund?.can_refund ? '환불 내역 없음' : order.payment_summary?.bank_amount ? '입금 확인 전' : '—')}</span>}
    </Summary>{refund?.can_refund && onRefund && <button type="button" aria-label={`주문 ${order.seq} 무통장 환불 완료 처리`}
      onClick={() => onRefund(order.seq)}>환불 완료 처리</button>}
  </Content></OrderCell>;
}

const Content = styled.div`
  display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; gap: var(--space-2); padding: var(--space-1); width: 100%; min-width: 0; white-space: nowrap;
  color: var(--color-text-primary); font-variant-numeric: tabular-nums;
  span, small { color: var(--color-text-secondary); white-space: nowrap; }
  button { flex-shrink: 0; }
  button { min-height: var(--control-sm); white-space: nowrap; padding: 0 var(--space-3); border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md); background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; cursor: pointer; }
  button:hover { background: var(--color-bg-subtle); }
  button:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
`;

const Summary = styled.div`
  display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  > * + * { margin-left: var(--space-2); }
`;
